import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Tab, Nav, Button, Spinner, Alert } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { useGetUserById } from '../../hooks/useGetUserById';
import ProfilTab from '../../components/Tabs/ProfilTabs/ProfilTab';
import SecurityTab from '../../components/Tabs/ProfilTabs/SecurityTab';
import PreferencesTab from '../../components/Tabs/ProfilTabs/PreferencesTab';

const UserManagement = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    
    // Fetch user data
    const { data: userData, isLoading, isError } = useGetUserById(userId);
    const user = userData?.data;

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" role="status" style={{ color: "#4e73df" }}>
                    <span className="visually-hidden">Chargement...</span>
                </Spinner>
            </div>
        );
    }

    if (isError || !user) {
        return (
            <Alert variant="danger">
                Erreur lors du chargement de l'utilisateur
            </Alert>
        );
    }

    return (
        <>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <div>
                    <Button 
                        variant="link" 
                        className="text-decoration-none ps-0 mb-2"
                        onClick={() => navigate('/administration?tab=utilisateurs')}
                    >
                        <FaArrowLeft className="me-2" />
                        Retour à l'administration
                    </Button>
                    <h1 className="h3 mb-0">
                        Gestion de l'utilisateur : {user.name} {user.surname}
                    </h1>
                </div>
            </div>

            <div className="mt-3 px-4">
                <Tab.Container defaultActiveKey="profil">
                    <Nav variant="tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="profil">Informations</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="securite">Sécurité</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="preferences">Préférences</Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-4">
                        <Tab.Pane eventKey="profil">
                            <ProfilTab userId={userId} isAdmin={true} userData={user} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="securite">
                            <SecurityTab userId={userId} isAdmin={true} userData={user} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="preferences">
                            <PreferencesTab userId={userId} isAdmin={true} userData={user} />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </div>
        </>
    );
};

export default UserManagement;
